/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import type {MetaType} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {POST, DELETE, GET, PUT} from '../../../../services/api'
import useModals from '../../../../hooks/useModals'
import {Loading} from '../../../../components/Loading/Loading'
import {Input} from '../../../../components/Input/Input'
import Swal from 'sweetalert2'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {i18n} from '../../../../translate/i18n'

type PostType = {
  id: number
  title: string
  content: string
  img: string
  status: boolean
  classificationPost: any
}

type categories = {
  value: string
  select: string
}

const Content: FC = () => {
  const navigate = useNavigate()
  const {showDeleteModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState<number | null>(null)
  const [, setMeta] = useState<MetaType | undefined>(undefined)

  const [filterCategoria, setFilterCategoria] = useState<any>({
    label: String(i18n.t(`hospitality_post.index.filter_all`)),
    value: 0,
  })
  const [publications, setPublications] = useState<PostType[]>([])
  const [categoria, setCategoria] = useState<categories[]>([])

  const switchStatus = async (Id: number, status: boolean) => {
    try {
      const switchClassification = await PUT(`/post/${Id}`, {
        status: !status,
      })
      if (switchClassification.success) {
        const newPublications = publications.map((publication) => {
          if (publication.id === id) {
            publication.status = !status
          }
          return publication
        })
        setPublications(newPublications)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getList = async (search: string = '') => {
    try {
      setLoading(true)
      const res = await POST(`/post/filter`, {
        classificationId: filterCategoria.value,
      })
      if (Object.getOwnPropertyDescriptor(res, 'data') === undefined) {
        return false
      }
      const publications = res.data.map((row: PostType) => {
        return {
          id: row.id,
          title: `${row.title}`,
          content: row.content,
          status: row.status,
          img: row.img,
          classification: row?.classificationPost?.name,
        }
      })

      setPublications(publications)

      setMeta(res.meta)
      setLoading(false)
    } catch (e) {
      setLoading(false)

      console.log(e)
    }
  }
  const getCategories = async () => {
    try {
      const resCategorias = await GET(`/classification-posts`)

      const categories = resCategorias.data.map((el: any) => {
        return {
          value: el.id,
          select: el.name,
        }
      })

      categories.push({
        select: String(i18n.t(`hospitality_post.index.filter_all`)),
        value: 0,
      })

      categories.sort((a: any, b: any) =>
        a.select.toUpperCase() > b.select.toUpperCase()
          ? 1
          : a.select.toUpperCase() < b.select.toUpperCase()
          ? -1
          : 0
      )

      setCategoria(categories)
    } catch (error) {
      console.log(error)
    }
  }

  async function getAllData() {
    setLoading(true)

    await Promise.all([getList(), getCategories()])

    setLoading(false)
  }

  useEffect(() => {
    getAllData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function deletePost() {
    try {
      const response = await DELETE(`/post/${id}`)

      if (!response || !response.success) {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao deletar',
          text: 'Falha ao deletar conteudo!',
        }).then(async () => await getList())
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Conteudo deletado',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getList())
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao deletar',
        text: 'Falha ao deletar conteudo!',
      }).then(async () => await getList())
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`hospitality_post.index.page_title`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`hospitality_post.index.page_subtitle`)}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t(`hospitality_post.index.add_button`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/hospitality/posts/criar')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-25 '>
                  <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>
                      {i18n.t(`hospitality_post.index.filter`)}
                    </span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      options={categoria}
                      placeholder={'Categoria'}
                      search={true}
                      value={filterCategoria}
                      change={(value: any) => setFilterCategoria(value)}
                    />
                  </div>
                </div>

                <div
                  className='d-flex align-items-end w-100 justify-content-end h-100'
                  style={{
                    marginTop: '48px',
                  }}
                >
                  <Button
                    text='Filtrar'
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-filter'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => getList()}
                    btnClass='mb-0 fw-bolder'
                  />
                </div>
              </div>
              <Datatable
                data={publications}
                headers={[
                  {
                    key: i18n.t(`hospitality_post.index.table.headers.image`),
                    value: 'img',
                    type: 'image',
                  },
                  {
                    key: i18n.t(`hospitality_post.index.table.headers.classification`),
                    value: 'classification',
                    type: 'default',
                  },
                  {
                    key: i18n.t(`hospitality_post.index.table.headers.title`),
                    value: 'title',
                    type: 'default',
                  },
                  {
                    key: i18n.t(`hospitality_post.index.table.headers.status`),
                    value: 'status',
                    type: 'check',
                    action: (item) => switchStatus(item.id, item.status),
                  },
                  {
                    key: i18n.t(`hospitality_post.index.table.headers.actions`),
                    value: 'acoes',
                    type: '',
                  },
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    title: i18n.t(`hospitality_post.index.actions.edit`),
                    action: (item) => {
                      navigate(`/hospitality/posts/editar/${item.id}`)
                    },
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      showDeleteModal(i18n.t(`hospitality_post.index.actions.delete`))
                      setId(item.id)
                    },
                    path: '',
                    title: i18n.t(`hospitality_post.index.actions.delete`),
                  },
                ]}
                color='primary'
              />
            </div>
          </div>
          <ModalDelete confirmAction={() => deletePost()} />
        </div>
      )}
    </>
  )
}

const PostIndex: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Conteúdos', path: 'hospitality/feed/content', isActive: true},
        ]}
      >
        Conteúdos
      </PageTitle>
      <Content />
    </>
  )
}

export {PostIndex}
